

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"46","height":"45","xmlns":"http://www.w3.org/2000/svg"}, rest), [h('g', {"transform":"translate(.5)","fill":"none","fill-rule":"evenodd"}, [h('ellipse', {"fill":"#FFF","cx":"22.5","cy":"22.468","rx":"22.5","ry":"22.468"}, []), h('path', {"d":"M18.873 12.5c-.432.048-.76.437-.758.899v4.793H10.51a.866.866 0 00-.088 0c-.432.048-.76.437-.757.898v11.384c0 .496.378.898.845.898h25.352c.467 0 .845-.402.845-.898v-7.789c0-.496-.378-.899-.845-.899h-7.606V13.4c0-.497-.378-.899-.845-.899h-8.45a.86.86 0 00-.088 0","fill":"#003E99","fill-rule":"nonzero"}, [])])]);
};

        